import React from 'react'; // eslint-disable-line
import styled from 'styled-components';

export default styled.div`
  background-image: linear-gradient(to right, #d9d9d9 40%, rgba(255, 255, 255, 0) 20%);
  background-position: top;
  background-size: 5px 1px;
  background-repeat: repeat-x;
  height: 1px;
`;



// WEBPACK FOOTER //
// ./src/components/Common/DashedBar.js